import React from 'react'

const PropertyDetailLoader = () => {
    return (
        <div>
            <div className='w-[100%] loader m-[auto] rounded-md h-[30rem] max-[617px]:h-[25rem] max-[480px]:h-[20rem] max-[390px]:h-[17rem] border-gray-300 border-[1px]'></div>
        </div>
    )
}

export default PropertyDetailLoader